<template>
  <div class="datepicker">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <div class="input-with-icon">
          <Img v-if="showIcon" :src="getImgWithExt(['icons', 'date', 'svg'])" class="input-icon" />
          <Input
            v-on="readonly ? on : {}"
            v-bind="$props"
            :readonly="readonly"
            v-mask="'##/##/####'"
            outlined
            radius="8"
            :placeholder="placeholder"
            :label="label"
            :value="formatDate"
            @input="handleManualInput"
            @blur="validateAndFix"
          />
        </div>
      </template>
      <v-date-picker
        no-title
        scrollable
        :show-current=false
        :max="$props.max"
        :min="$props.min"
        @change="changeDate"
        :value="datePickerValue"
      />
    </v-menu>
  </div>
</template>

<script>
import Input from '@/components/elements/Input'
import Img from '@/components/elements/Img'
import Image from '@/mixins/Image'

export default {
  name: 'datepicker',
  props: {
    color: {
      default: '#212b37',
      type: String
    },
    format: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    label: {
      type: String
    },
    max: {
      type: String
    },
    min: {
      type: String
    },
    placeholder: String,
    rules: {
      type: [Array, String, Object]
    },
    'type-picker': {
      type: String
    },
    showCurrent: {
      type: String
    },
    value: {
      type: [String, Date]
    },
    height: { type: [String, Number] },
    showIcon: {
      default: true,
      type: Boolean
    },
    readonly: {
      type: Boolean,
      default: true
    }
  },
  mixins: [Image],
  components: { Input, Img },
  data: () => ({
    date: null,
    displayValue: null,
    menu: false
  }),
  watch: {
    value(newVal) {
      this.displayValue = null
      this.date = newVal
    }
  },
  computed: {
    datePickerValue () {
      const dateToParse = this.date || this.value || new Date()
      return this.$moment(dateToParse, ['YYYY-MM-DD', 'MM/DD/YYYY', 'M/D/YYYY']).format('YYYY-MM-DD')
    },

    formatDate () {
      if (this.displayValue !== null) return this.displayValue

      if (this.date) {
        return this.$moment(this.date).format('MM/DD/YYYY')
      }
      if (this.value) {
        return this.$moment(this.value, ['YYYY-MM-DD', 'MM/DD/YYYY', 'M/D/YYYY']).format('MM/DD/YYYY')
      }
      return ''
    }
  },
  methods: {
    handleManualInput(val) {
      if (this.readonly) return

      this.displayValue = val

      const cleanVal = val.replace(/_/g, '').trim()

      if (cleanVal.length === 10) {
        const parsedDate = this.$moment(val, 'MM/DD/YYYY', true)

        if (parsedDate.isValid()) {
          const technicalDate = parsedDate.format('YYYY-MM-DD')
          this.$emit('date:update', technicalDate)
        }
      }
    },

    validateAndFix() {
      if (this.readonly) return

      if (this.displayValue === null) return

      const cleanVal = this.displayValue.replace(/_/g, '').trim()

      const parsedDate = this.$moment(cleanVal, 'MM/DD/YYYY', true)

      if (!cleanVal || !parsedDate.isValid()) {
        this.$emit('date:update', null)
      } else {
        this.$emit('date:update', parsedDate.format('YYYY-MM-DD'))
      }

      this.displayValue = null
    },

    changeDate ($event) {
      // this.date = $event
      this.displayValue = null
      this.$emit('date:update', $event)
      this.$refs.menu.save()
    }
  }
}
</script>

<style lang="scss" scoped>
.datepicker {
  .input-with-icon {
    display: flex;
    align-items: center;
    background-color: #EDF2F7;
    border-radius: 8px;
    padding: 10px 16px;

    .image {
      width: 14px;
      margin-right: 8px;
    }

    .input {
      ::v-deep .v-input__control {
        .v-input__slot {
          height: auto !important;
          box-shadow: none;
          border: none !important;
          padding: 0 !important;

          fieldset {
            padding-left: 0 !important;
          }

          .v-text-field__slot {
            input[readonly] {
              cursor: pointer;
            }

            input {
              color: #7A828A !important;
              font-weight: 500;
              font-size: 13px;
              padding: 0;

              &::placeholder {
                color: #7A828A;
                font-weight: 500;
                font-size: 13px;
              }
            }
          }
        }
        .v-text-field__details {
          display: none;
        }
      }
    }
  }
}
::v-deep .v-picker {
  .v-date-picker-table .v-btn.v-btn--active {
    background-color: $dark-green !important;
    color: $white !important;
  }
}
</style>
